// extracted by mini-css-extract-plugin
export default {"dataTable":"ClickRateTable_dataTable__15koo","collapsed":"ClickRateTable_collapsed__4rRk7","extended":"ClickRateTable_extended__eNVeO"};